import React, { useState, useEffect } from "react";
import {
  StyledCheckbox,
  CenteredLoader,
} from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import { CircleBtn, PopUpContainer } from "assets/css/globle";
import RefreshIcon from "assets/svgIcons/ResendIcon";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

import {
  Container,
  Header,
  BodyContainer,
  Heading,
  DaysWrapper,
  ActionBtn,
} from "pages/Pins/DailyRotationDays/DailyRotationDaysStyled";
import { GlobalCourseIdState, SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { uuid } from "_helperFunctions/uuid";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { Loader } from "commonComponents/Loader/Loader";
import { setAppDataReduxStateAction } from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import { Box, Button, Modal } from "@mui/material";
import { useLayoutEffect } from "react";
import { setDailyRotationReduxStateAction } from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import { useTranslation } from "react-i18next";
import { isUserBasic, isUserReadOnly } from "constant";

export const DailyRotationDays = () => {
  const { t } = useTranslation();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const dispatch = useDispatch();
  
  const { globalCourseId } = useHookstate(GlobalCourseIdState);
  const [dailyRotationState, setDailyRotationState] = useState([]);
  const [showButtons, setShowButtons] = useState(false);
  const [courseNumber, setCourseNumber] = useState();
  const [rotationData, setRotationData] = useState([]);
  const [resetWeekDay, setResetWeekDay] = useState([]);
  const [resetDailyRotation, setResetDailyRotation] = useState([]);
  const [rotationDaysValue, setRotationDaysValue] = useState([]);
  const [weekDaysState, setWeekDaysState] = useState([]);
  const {
    siteSettingsDataReduxState,
    siteIdData,
    appDataReduxState: { courseNumber: courseNumberData } = {},
  } = useSelector((state) => state.firstReducer);

  const [discardPopUp, setDiscardPopUp] = useState(false);
  const {
    greensWithPinPlacementStateData,
    greensWithPinPlacementStateStatus,
    getUserRole,
  } = useSelector((state) => state.commonReducers) || [];

  useEffect(() => {
    dispatch(COMMON_SERVICES.getGreensWithPinPlacementsServices(siteId.get()));
    dispatch(COMMON_SERVICES.getCarPinPlacementsServices(siteId.get()));
    let getCourseid = localStorage.getItem("courseId");
    if (getCourseid) {
      setCourseNumber(getCourseid);
    }
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getGreensWithPinPlacementsServices(siteId.get()));
  }, [siteIdData, courseNumberData]);

  useLayoutEffect(() => {
    const dailyRotationData =
      greensWithPinPlacementStateData &&
      greensWithPinPlacementStateData?.RotationDays &&
      greensWithPinPlacementStateData?.RotationDays?.Rotate;

    dispatch(setDailyRotationReduxStateAction(dailyRotationData));
  }, []);

  useEffect(() => {
    const newVar =
      greensWithPinPlacementStateData &&
        greensWithPinPlacementStateData?.RotationDays &&
        greensWithPinPlacementStateData?.RotationDays?.RotateDays &&
        greensWithPinPlacementStateData?.RotationDays?.RotateDays.length !== 0
        ? greensWithPinPlacementStateData?.RotationDays?.RotateDays.map(
          (item) => item
        )
        : null;

    const rotationDataValue = newVar && newVar.map((item) => item?.Key);
    const rotationDaysDataValue =
      newVar &&
      newVar.map((item) => {
        if (item?.Key === "Sunday" && item?.Value === true) {
          return 1;
        } else if (item?.Key === "Monday" && item?.Value === true) {
          return 2;
        } else if (item?.Key === "Tuesday" && item?.Value === true) {
          return 4;
        } else if (item?.Key === "Wednesday" && item?.Value === true) {
          return 8;
        } else if (item?.Key === "Thursday" && item?.Value === true) {
          return 16;
        } else if (item?.Key === "Friday" && item?.Value === true) {
          return 32;
        } else if (item?.Key === "Saturday" && item?.Value === true) {
          return 64;
        } else {
          return null;
        }
      });

    const dailyRotationData = [
      {
        Key: "Rotate",
        Value:
          greensWithPinPlacementStateData &&
          greensWithPinPlacementStateData?.RotationDays &&
          greensWithPinPlacementStateData?.RotationDays?.Rotate,
      },
    ];

    setDailyRotationState(dailyRotationData);
    setResetDailyRotation(dailyRotationData);

    setRotationData(rotationDataValue);
    setRotationDaysValue(rotationDaysDataValue);
    setWeekDaysState(newVar);
    setResetWeekDay(newVar);
  }, [greensWithPinPlacementStateData]);

  const cancelFunc = () => {
    setDiscardPopUp(true);
  };

  const changeCheckBoxValue = (e, dayName, dayValue) => {
    setShowButtons(true);
    const exists = rotationData.find((item) => item === dayName);
    const existValues = rotationDaysValue.find((item) => item === dayValue);
    if (exists && existValues) {
      const newData = rotationData.filter((item) => item !== dayName);
      const newValues = rotationDaysValue.filter((item) => item !== dayValue);
      setRotationData(newData);
      setRotationDaysValue(newValues);
    } else {
      setRotationData([...rotationData, dayName]);
      setRotationDaysValue([...rotationDaysValue, dayValue]);
    }
    setWeekDaysState(
      weekDaysState &&
      weekDaysState.map((item) =>
        item.Key === dayName ? { ...item, Value: e.target.checked } : item
      )
    );
  };

  const savePinsWeekDays = () => {
    if (rotationDaysValue.length !== 0) {
      const sum = rotationDaysValue.reduce(
        (partialSum, a) => partialSum + a,
        0
      );
      dispatch(
        COMMON_SERVICES.courseRotationDaysServices({
          CourseRotationDays: {
            Course: localStorage.getItem("courseId")
              ? localStorage.getItem("courseId")
              : courseNumberData,
            Rotate:
              dailyRotationState && dailyRotationState.length !== 0
                ? dailyRotationState[0].Value
                : dailyRotationState[0].Value,
            RotationDays: sum,
          },
          Log: "Rotation days changed",
          SiteId: siteIdData,
        })
      );
    } else {
      dispatch(
        COMMON_SERVICES.courseRotationDaysServices({
          CourseRotationDays: {
            Course: localStorage.getItem("courseId")
              ? localStorage.getItem("courseId")
              : courseNumberData,
            Rotate:
              dailyRotationState && dailyRotationState.length !== 0
                ? dailyRotationState[0].Value
                : dailyRotationState[0].Value,
            RotationDays: 0,
          },
          Log: "Rotation days changed",
          SiteId: siteIdData,
        })
      );
    }
    setShowButtons(false);
    dispatch(COMMON_SERVICES.getGreensWithPinPlacementsServices(siteId.get()));
  };

  const refreshUI = () => {
    dispatch(COMMON_SERVICES.getGreensWithPinPlacementsServices(siteId.get()));
  };

  const dailyRotationStateHandler = (e, rotationName, rotationValue) => {
    setShowButtons(true);
    setDailyRotationState(
      dailyRotationState &&
      dailyRotationState.map((item) =>
        item.Key === rotationName
          ? { Key: "Rotate", Value: e.target.checked }
          : item
      )
    );
  };

  const handleCourseName = (e) => {
    let courseValue = Number(e.target.value);
    dispatch(
      setAppDataReduxStateAction({
        parameterDetector: "coursenumber",
        value: courseValue,
      })
    );
    setCourseNumber(Number(e.target.value));
    localStorage.setItem("courseId", Number(e.target.value));
    globalCourseId.set(Number(e.target.value));
  };

  const rerenderData = () => {
    setWeekDaysState(resetWeekDay);
    setDailyRotationState(resetDailyRotation);
    setDiscardPopUp(false);
    setShowButtons(false);
  };

  const showDiscardBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "444px",
      width: "100%",
      bgcolor: "background.paper",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={discardPopUp}
        onClose={() => setDiscardPopUp(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>
              {t("Confirm")}
            </h2>
            <p>
              {t("Discard_changes")}?
            </p>
            <div className="action-btn">
              <button onClick={() => rerenderData()} className="primary">
                {t("Yes")}
              </button>
              <button onClick={() => setDiscardPopUp(false)}>{t("No")}</button>

            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  if (greensWithPinPlacementStateStatus === "request") {
    return (
      <CenteredLoader>
        <Loader />
      </CenteredLoader>
    );
  }

  return (
    <Container>
      {showDiscardBox()}
      <Header>
        <FormControl>
          <Select
            native
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-select"
            variant="outlined"
            value={courseNumber}
            onChange={handleCourseName}
          // IconComponent={() => (
          //   <div style={{ padding: "0 5px", display: "flex", cursor:"pointer" }}>
          //     <SelectArrow />
          //   </div>
          // )}
          >
            {siteSettingsDataReduxState &&
              siteSettingsDataReduxState?.Courses &&
              siteSettingsDataReduxState?.Courses.length !== 0 ? (
              siteSettingsDataReduxState?.Courses.map((item, index) => (
                <option value={item?.Number} key={index + "sdbfjsd"}>
                  {item?.Name}
                </option>
              ))
            ) : (
              <option value=""></option>
            )}
          </Select>
        </FormControl>
        <CircleBtn onClick={refreshUI}>
          <RefreshIcon color="#fff" />
          {t("Refresh")}
        </CircleBtn>
      </Header>
      {/* <div className="container">
        <FormWraper className="ground-select"></FormWraper>
      </div> */}
      <BodyContainer>
        <Heading>{t("Daily_Rotation_Setup")}</Heading>
        {dailyRotationState &&
          dailyRotationState.length !== 0 &&
          greensWithPinPlacementStateStatus === "success" ? (
          dailyRotationState.map((item, index) => (
            <StyledCheckbox className="header-checkbox" key={uuid()}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={
                      isUserBasic(getUserRole && getUserRole?.Role) ||
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    onChange={(e) =>
                      dailyRotationStateHandler(e, item?.Key, item?.Value)
                    }
                    name={item?.Key}
                    checked={item?.Value}
                    icon={<UnCheckIcon width={18} height={18} />}
                    checkedIcon={<CheckIcon width={18} height={18} />}
                  />
                }
                label={t("Enable_Daily_Rotations")}
              />
            </StyledCheckbox>
          ))
        ) : (
          <></>
        )}

        <DaysWrapper>
          {weekDaysState &&
            weekDaysState.length !== 0 &&
            greensWithPinPlacementStateStatus === "success" ? (
            weekDaysState.map((item, index) => (
              <StyledCheckbox className="checkbox" key={uuid()}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={item?.Value}
                      name={item?.Key}
                      onChange={(e) =>
                        changeCheckBoxValue(
                          e,
                          item?.Key,
                          item?.Key === "Sunday"
                            ? 1
                            : item?.Key === "Monday"
                              ? 2
                              : item?.Key === "Tuesday"
                                ? 4
                                : item?.Key === "Wednesday"
                                  ? 8
                                  : item?.Key === "Thursday"
                                    ? 16
                                    : item?.Key === "Friday"
                                      ? 32
                                      : item?.Key === "Saturday"
                                        ? 64
                                        : 0,
                          index
                        )
                      }
                      icon={<UnCheckIcon width={18} height={18} />}
                      checkedIcon={<CheckIcon width={18} height={18} />}
                    />
                  }
                  label={t(item?.Key)}
                />
              </StyledCheckbox>
            ))
          ) : (
            <h2>{t("No_Data_Found")}</h2>
          )}
        </DaysWrapper>
        <ActionBtn>
          <Button variant="outlined"
            disabled={
              isUserBasic(getUserRole && getUserRole?.Role) ||
              isUserReadOnly(getUserRole && getUserRole?.Role)
            }
            onClick={cancelFunc}
            className={showButtons ? "" : "disabled"}
          >
            {/* <CloseIcon width={20} height={20} color={showButtons ? "#000000" : "#00000042"} />  */}
            {t("Cancel")}

          </Button>
          <Button variant="outlined"
            // startIcon={<SaveChangeIcon color={siteSettingsData?.VodafoneCspId ==
            //   selectedCustomerServiceProfile.get() ? "#00000042" : "#1D1D1D"} />}
            disabled={
              isUserBasic(getUserRole && getUserRole?.Role) ||
              isUserReadOnly(getUserRole && getUserRole?.Role)
            }
            onClick={() => savePinsWeekDays()}
            className={showButtons ? "active" : "disabled"}
          >
            {/* <SaveChangeIcon color={showButtons ? "#fff" : "#00000042"} />  */}
            {t("Save")}
          </Button>
        </ActionBtn>

      </BodyContainer>
    </Container>
  );
};
